import React from 'react';
// library to set properties for components
import PropTypes from 'prop-types';
// @material-ui/core
import Menu from '@material-ui/core/Menu';

const ITEM_HEIGHT = 48;

/**
 * @class
 * @hideconstructor
 * @description Core Menu component
 */
const CustomMenu = ({
  anchorEl,
  id,
  children,
  handleClose,
  anchorOrigin,
  transformOrigin,
  disableContentAnchor,
  transitionComponent,
  transitionProps,
  onMouseEnter,
  onMouseLeave
}) => {
  const open = Boolean(anchorEl);
  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'top',
          horizontal: 'right'
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'right'
        }
      }
      open={open}
      onClose={handleClose}
      getContentAnchorEl={disableContentAnchor ? null : undefined}
      TransitionComponent={transitionComponent}
      TransitionProps={transitionProps}
      PaperProps={{
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: 200
        },
        onMouseEnter,
        onMouseLeave
      }}
    >
      {children}
    </Menu>
  );
};

// component properties
CustomMenu.propTypes = {
  /**
   * @type {string}
   * @description - ID of the menu component
   */
  id: PropTypes.string.isRequired,
  /**
   * @type {element}
   * @description - Target element
   */
  anchorEl: PropTypes.any,
  /**
   * @type {function | element}
   * @description Child elements
   */
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]).isRequired,
  /**
   * @type {function}
   * @description - Callback function to handle the menu close
   */
  handleClose: PropTypes.func.isRequired,
  anchorOrigin: PropTypes.object,
  transformOrigin: PropTypes.object,
  disableContentAnchor: PropTypes.bool,
  transitionComponent: PropTypes.any,
  transitionProps: PropTypes.object,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};

CustomMenu.defaultProps = {
  anchorEl: null,
  anchorOrigin: null,
  transformOrigin: null,
  disableContentAnchor: false,
  transitionComponent: undefined,
  transitionProps: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined
};

export default CustomMenu;
